export default __webpack_public_path__ + "static/remote-4f24354d2a306c188fce19b18e6aa5a1.png";